import { DadosSolicitacaoPessoal } from "../model/entities/SolicitacaoPessoal";
import api from "./api";

const ROUTE = "solicitacao_pessoal";

class solicitacaoPessoalApi {
  async getById(id: number) {
    try {
      const res = await api.get<DadosSolicitacaoPessoal>(`/${ROUTE}/${id}`);
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }
  async getMany(
    pagina: number,
    linhasPorPagina: number,
    campoOrdenacao: string = "id",
    direcao: "asc" | "desc" = "asc"
  ) {
    try {
      const res = await api.get(
        `/${ROUTE}?size=${linhasPorPagina}&page=${pagina}&sort=${campoOrdenacao},${direcao}`
      );

      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async count() {
    try {
      const res = await api.get<number>(`/${ROUTE}/count`);
      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }

  async countSolicitacoesPessoaisNaData(dataDia: Date) {
    try {
      const res = await api.get<number>(
        `/${ROUTE}/countSolicitacoesPessoaisNaData`,
        {
          params: {
            date: dataDia,
          },
        }
      );
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }
}

const apiSolicitacaoPessoal = new solicitacaoPessoalApi();
export default apiSolicitacaoPessoal;
